import { render, staticRenderFns } from "./OtherLifeInsuranceForEdit.vue?vue&type=template&id=bfe64716"
import script from "./OtherLifeInsuranceForEdit.vue?vue&type=script&lang=js"
export * from "./OtherLifeInsuranceForEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports